import script from "./LabItemView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabItemView.vue?vue&type=script&setup=true&lang=ts"

import "./LabItemView.vue?vue&type=style&index=0&id=6f982c0e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f982c0e"]])

export default __exports__